import './StatCard.css';

const StatCard = ({ title, value, icon: Icon, trend, trendValue, sub, color = '#3B82F6' }) => {
  const isPositive = trend === 'up';

  return (
    <div className="sc">
      <div className="sc-icon" style={{ background: `${color}18`, color }}>
        {Icon && <Icon size={18} />}
      </div>
      <div className="sc-body">
        <span className="sc-title">{title}</span>
        <span className="sc-value">{value}</span>
        {sub && <span className="sc-sub">{sub}</span>}
        {trendValue && (
          <div className={`sc-trend${isPositive ? ' sc-trend--up' : ' sc-trend--down'}`}>
            <i className={`pi ${isPositive ? 'pi-arrow-up' : 'pi-arrow-down'}`}></i>
            <span>{trendValue}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default StatCard;
